module.exports = __webpack_public_path__ + "static/media/gates.64f5a9e1.gif";